

export * from './codeitem.service';
export * from './device-category.service';
export * from './device-icons.service';
export * from './event.service';
export * from './guided-button.service';
export * from './items.service';
export * from './utils.service';

import { ItemsService } from './items.service';
import { CodeItemService } from './codeitem.service';
import { ProgrammingUtilsService } from './utils.service';
import { DeviceCategoryService } from './device-category.service';

export const ADVANCED_PROGRAMMING_SERVICES: Array<any> = [
  CodeItemService,
  DeviceCategoryService,
  ItemsService,
  ProgrammingUtilsService
];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/services/index.ts